<template>
  <div>
    <v-app-bar
      color="black"
      dense
      dark
    >
      <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->

      <v-toolbar-title >  <span class=" PB" >   KL06</span>    </v-toolbar-title>

      <v-spacer>   </v-spacer>

      <v-btn icon>
       <AccountMenu/>
      </v-btn>

     

    </v-app-bar>
  </div>
</template>
<script>
// import AccountMenu from "./../components/accountMenu";
import AccountMenu from "./accountMenu.vue"
export default {
  components:{
    AccountMenu
  }
  
}
</script>